module.exports = __webpack_public_path__ + "media/images/icon_list/marker-f4e92ec22d1c1bcf5464e15a2762cc44.svg";